import { useEffect, useState } from 'react';
import { getLiveSignal, type LiveSignalData } from '@/services/indexService';

function formatSessionTime(): string {
  const now = new Date();
  return now.toTimeString().slice(0, 8);
}

const FALLBACK: LiveSignalData = {
  active_audits: 0,
  queued: 0,
  avg_latency_ms: 42,
  last_event: null,
};

export default function IndexStatusFooter() {
  const [sessionTime, setSessionTime] = useState(formatSessionTime);
  const [signal, setSignal] = useState<LiveSignalData>(FALLBACK);
  const [live, setLive] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setSessionTime(formatSessionTime()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const data = await getLiveSignal();
        if (!cancelled) {
          setSignal(data);
          setLive(true);
        }
      } catch {
        if (!cancelled) setLive(false);
      }
    };
    void load();
    const poll = setInterval(() => void load(), 30_000);
    return () => {
      cancelled = true;
      clearInterval(poll);
    };
  }, []);

  const latency = live ? signal.avg_latency_ms : 42;

  return (
    <footer className="border-t border-[#2a2a2a] bg-[#0a0a0a] px-4 py-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-[10px] font-mono uppercase tracking-wider text-white/35">
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-index-cleared" aria-hidden />
        Secure TLS 1.3
      </span>
      <span>Encrypted at rest · AES-256</span>
      <span>SOC 2 Type II</span>
      <span className="hidden sm:inline">
        Audits {signal.active_audits} · Queue {signal.queued}
      </span>
      <span className="hidden sm:inline">
        Latency ~{latency}ms{live ? '' : ' (static)'}
      </span>
      <span className="hidden lg:inline truncate max-w-[200px]">
        {signal.last_event ?? 'Node EU-WEST-4'}
      </span>
      <span className="ml-auto tabular-nums">Session {sessionTime}</span>
    </footer>
  );
}
